module.exports = __webpack_public_path__ + "assets/img/driver-btn-d68afa46.png";